import { render, staticRenderFns } from "./TutorTrans2.vue?vue&type=template&id=f9ec9286&scoped=true&lang=pug&"
import script from "./TutorTrans2.vue?vue&type=script&lang=js&"
export * from "./TutorTrans2.vue?vue&type=script&lang=js&"
import style0 from "./TutorTrans2.vue?vue&type=style&index=0&id=f9ec9286&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ec9286",
  null
  
)

export default component.exports